(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // OverDMA: px of scrolling in one direction before the on-scroll-up header hides or comes back
  const SCROLL_RUN = 24;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // OverDMA: --header-height (scroll-padding-top) follows every change of height, not only the 990px switch:
      // fonts loading, the shopper's larger text, a menu link wrapping to a second row
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = this.scrollPosition();
      this.scrollRun = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // OverDMA (contract C1): html[data-odma-jump] is set around a programmatic in-page scroll (assets/odma-catalog.js).
      // It brings the header into view; when it goes, the direction is measured afresh from where the page is.
      this.jumpObserver = new MutationObserver(() => {
        this.currentScrollTop = this.scrollPosition();
        this.scrollRun = 0;
        if (this.isJumping()) this.reveal();
      });
      this.jumpObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-odma-jump'] });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.resizeObserver.disconnect();
      this.jumpObserver.disconnect();
    }

    // OverDMA: the page offset clamped to the scrollable range. iOS rubber-banding reports offsets past both ends;
    // clamped, the bounce at the bottom reads as no movement instead of a scroll up that slid the header in.
    scrollPosition() {
      const max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
      return Math.min(Math.max(window.pageYOffset || document.documentElement.scrollTop, 0), max);
    }

    isJumping() {
      return document.documentElement.hasAttribute('data-odma-jump');
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        // OverDMA: the page opened on a section (/#hardware from another page): show the header above it,
        // so the room scroll-padding-top keeps for it is not an empty band
        if (!entries[0].isIntersecting && document.querySelector(':target')) this.reveal();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = this.scrollPosition();
      const delta = scrollTop - this.currentScrollTop;
      this.currentScrollTop = scrollTop;

      if (!delta || (this.predictiveSearch && this.predictiveSearch.isOpen)) return;

      // OverDMA: the bar moves only after a run of SCROLL_RUN px in one direction, so finger jitter
      // and small corrections no longer flip it
      this.scrollRun = Math.sign(delta) === Math.sign(this.scrollRun) ? this.scrollRun + delta : delta;
      const pastHeader = scrollTop > this.headerBounds.bottom;
      if (pastHeader) this.header.classList.add('scrolled-past-header');

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      } else if (this.isJumping()) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (delta > 0 && pastHeader) {
        if (this.preventHide || this.scrollRun < SCROLL_RUN) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (delta < 0 && pastHeader && this.preventReveal) {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      } else if (delta < 0 && !this.preventReveal) {
        // near the top the hidden header's own place comes into view: bring it back without waiting for the run
        const hidden = this.header.classList.contains('shopify-section-header-hidden');
        if (pastHeader ? this.scrollRun <= -SCROLL_RUN : hidden) requestAnimationFrame(this.reveal.bind(this));
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.scrollRun = 0;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.scrollRun = 0;
      // OverDMA: scrolled out of view in the page flow, it would pop in; start it just above the screen so it slides in
      if (!this.header.classList.contains('shopify-section-header-sticky') && this.header.getBoundingClientRect().bottom <= 0) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.header.getBoundingClientRect(); // apply that start position before the transition
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
